import React from "react";
import { SnackbarProvider } from "notistack";
import Routes from "./Routes";
import RTUThemeProvider from "./RTUThemeProvider";
import TokenRenewer from "./features/TokenRenewer";

function App() {
  window.onbeforeunload = (event) => {
    window.localStorage.unloadTime = JSON.stringify(new Date());
  };

  window.onload = function () {
    let howMuchSecondsToWait = 3600;
    let loadTime = new Date();
    let unloadTime = new Date(JSON.parse(window.localStorage.unloadTime));
    let refreshTime = loadTime.getTime() - unloadTime.getTime();

    if (refreshTime > howMuchSecondsToWait * 1000) {
      localStorage.removeItem("user");
      localStorage.removeItem("bearer-token");
    }else{
      localStorage.removeItem("unloadTime");
    }
  };

  return (
    <>
      <RTUThemeProvider>
        <SnackbarProvider>
          <Routes />
        </SnackbarProvider>
      </RTUThemeProvider>

      {/* APP Listeners */}
      {/* <TokenRenewer /> */}
    </>
  );
}

export default App;
